import SkipMenu from './SkipMenu';

export default SkipMenu;
